export const getOuterCuttingLinePathData = (self) => {
  return self._outer_cutting_line_path_data;
};
